<template>
    <div class="pet-quote-step select-coverage">
        <quote-step-header
            :title="subStepFields.title"
            :key="subStepFields.title"
            :subtitle="subStepFields.subtitle"
        ></quote-step-header>

        <form class="quote-form" @submit.prevent="next">
            <div v-for="question in questions" :key="question.label">
                <app-label>{{ trans(`labels.${question.label}`) }}</app-label>
                <app-text-radio-buttons
                    class="mb-16"
                    v-model="form[stepName][question.field]"
                    :items="items"
                    :break-mobile="true"
                ></app-text-radio-buttons>
            </div>
            <div class="submit-row">
                <app-button :disabled="disabledConditions" :loading="loading">
                    {{ "quote.welcome.next" | __ }}
                </app-button>
            </div>
        </form>
    </div>
</template>

<script>
import QuoteStep from "../../../mixins/QuoteStep";
import AppInput from "../../Forms/Input.vue";
import AppLabel from "../../Forms/Label.vue";

export default {
    name: "PetQuotePetInfo",
    components: { AppInput, AppLabel },
    mixins: [QuoteStep],

    props: {},

    data() {
        return {
            subSteps: ["default"],
            items: [
                {
                    label: this.trans("yes"),
                    value: true
                },
                {
                    label: this.trans("no"),
                    value: false
                }
            ],
            questions: [
                {
                    label: "pet_healthy",
                    field: "healthy"
                },
                {
                    label: "had_medical_surgery",
                    field: "medical_surgery"
                },
                {
                    label: "medical_issues",
                    field: "health_issues"
                },
                {
                    label: "accident",
                    field: "accident"
                },
                {
                    label: "medical_treatment",
                    field: "medical_treatment"
                }
            ]
        };
    },

    computed: {
        canMoveNext() {
            const {
                healthy,
                medical_surgery,
                health_issues,
                accident,
                medical_treatment
            } = this.form[this.stepName];
            return (
                healthy != null &&
                medical_surgery != null &&
                health_issues != null &&
                accident != null &&
                medical_treatment != null
            );
        }
    }
};
</script>

<style lang="scss" scoped>
.quote-form {
    max-width: $tablet;
    height: auto;
}

.floors {
    display: flex;
    gap: 40px;

    @media (max-width: $tablet) {
        flex-direction: column;
    }

    > div {
        flex: 1;
    }
}

ul {
    list-style: disc;
}
</style>
